// ─────────────────────────────────────────────────────────────────────
// What's New — edit this file to update new-content indicators
// across the whole site (sidebar *, home panel, nav cards).
//
// Each entry drives:
//   • The glowing * in the sidebar next to that page
//   • A row in the "What's New" collapsible panel on the home page
//   • The * on the matching library link on the home page
//
// The * disappears per-item after the user spends ~5 seconds on the page.
// Pages with a Source filter also make the newest source's button (NEW_SOURCE)
// glow gold; clicking it clears that glow for that page.
//
// To start a new release cycle: update the items below and change
// SEEN_KEY / FILTER_KEY_PREFIX to fresh strings so all * reappear.
// ─────────────────────────────────────────────────────────────────────

export interface WhatsNewItem {
  path: string;
  label: string;
  description: string;
  date: string;
}

export const WHATS_NEW_ITEMS: WhatsNewItem[] = [
  { path: '/character-creation', label: 'Character Creation', description: 'Build a character, level up, save it as a PDF', date: 'Oct 2026' },
  { path: '/classes',         label: 'Classes',         description: 'Hope & Fear Assassin, Brawler, Warlock, Witch', date: 'Oct 2026' },
  { path: '/domains',         label: 'Domains',         description: 'Hope & Fear Dread domain',                       date: 'Oct 2026' },
  { path: '/ancestries',      label: 'Ancestries',      description: 'Hope & Fear versions',           date: 'Oct 2026' },
  { path: '/communities',     label: 'Communities',     description: 'Hope & Fear versions',          date: 'Oct 2026' },
  { path: '/transformations', label: 'Transformations', description: 'Hope & Fear versions',      date: 'Oct 2026' },
  { path: '/equipment',       label: 'Equipment',       description: 'Hope & Fear weapons and armor',      date: 'Oct 2026' },
  { path: '/gm-tools',        label: 'GM Guidance',     description: 'Villain builder, doom track',   date: 'Oct 2026' },
  { path: '/kohd',            label: 'Kohd Writer',     description: 'Write and edit Kohd circuits',  date: 'Oct 2026' },
];

export const WHATS_NEW_TITLE = "What's new";

// localStorage keys — bump these strings to reset all indicators for a new release
export const SEEN_KEY         = 'dhtools_v16_seen';        // JSON array of visited paths
export const PANEL_KEY        = 'dhtools_v16_panel_open';  // 'true' | 'false'
export const FILTER_KEY_PREFIX = 'dhtools_v16_filter_';    // + page slug → '1' when clicked

// The Source filter option of the newest expansion; its button glows until clicked
export const NEW_SOURCE = 'Hope & Fear';
